module.exports = __webpack_public_path__ + "static/media/logo_atlantic.093d36f7.svg";